<template>
  <div class="column">
    <woot-modal-header :header-title="$t('WEBHOOKS_SEND_MESSAGES.ADD.TITLE')" :header-content="$t('WEBHOOKS_SEND_MESSAGES.ADD.DESC')" />
    <webhook-form
      :is-submitting="uiFlags.isCreating"
      @submit="onSubmit"      
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MultiselectDropdown from 'shared/components/ui/MultiselectDropdown';
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import TemplatesPicker from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplatesPicker';
import TemplateParser from 'dashboard/components/widgets/conversation/WhatsappTemplates/TemplateParser';
import WebhookForm from './Form';

import alertMixin from 'shared/mixins/alertMixin';

export default {
  mixins: [alertMixin],
  components: {
    TemplatesPicker,
    TemplateParser,
    MultiselectDropdown,
    WootMessageEditor,
    WebhookForm,
  },  
  computed: {
    ...mapGetters({
      uiFlags: 'webhooksSendMessages/getUIFlags',
    })
  },
  methods: {
    ...mapActions('webhooksSendMessages', ['create']),
    async onSubmit(webhook) {
      try {
        await this.create({ webhooks_send_messages: {...webhook, 'partner': 'autoavaliar'} });

        this.showAlert(this.$t('WEBHOOKS_SEND_MESSAGES.ADD.API.SUCCESS_MESSAGE'));
        this.$emit('on-created');
      } catch (error) {
        this.showAlert(this.$t('WEBHOOKS_SEND_MESSAGES.ADD.API.ERROR_MESSAGE'));
      } finally {
        this.onClose();
      }
    },
    onClose() {
      this.$emit('on-close');
    }    
  },
  mounted() {    
  },
};
</script>
